export default "__VITE_ASSET__7622dec9__"